import React from "react";
import { Typography } from "@mui/material";

import LegalPage from "./LegalPage";
import LegalSection from "./LegalSection";
import {
  CONTROLLER_NAME,
  LEGAL_EFFECTIVE_DATE,
  PLATFORM_NAME,
  PRIVACY_CONTACT_EMAIL,
} from "./legalContentConstants";

const SECTIONS = [
  { id: "acceptance", title: "1. Acceptance of these Terms" },
  { id: "service", title: "2. The Service" },
  { id: "accounts", title: "3. Accounts and eligibility" },
  { id: "acceptable-use", title: "4. Acceptable use" },
  { id: "user-content", title: "5. Your content" },
  { id: "intellectual-property", title: "6. Intellectual property" },
  { id: "third-parties", title: "7. Third-party services" },
  { id: "availability", title: "8. Availability and changes" },
  { id: "disclaimer", title: "9. Disclaimers" },
  { id: "liability", title: "10. Limitation of liability" },
  { id: "termination", title: "11. Suspension and termination" },
  { id: "changes", title: "12. Changes to these Terms" },
  { id: "law", title: "13. Governing law" },
  { id: "contact", title: "14. Contact" },
];

const TermsOfUse = () => {
  return (
    <LegalPage
      title="Terms of Use"
      intro={`These Terms of Use govern your access to and use of the ${PLATFORM_NAME} operated by ${CONTROLLER_NAME}. Effective date: ${LEGAL_EFFECTIVE_DATE}.`}
      sections={SECTIONS}
    >
      <LegalSection id="acceptance" title="1. Acceptance of these Terms">
        <Typography variant="body1">
          By creating an account or otherwise using the Service you confirm that
          you have read, understood and agree to be bound by these Terms. If you
          do not agree, you must not use the Service.
        </Typography>
        <Typography variant="body1">
          TODO(legal): confirm the exact wording and that all users must accept
          these Terms.
        </Typography>
      </LegalSection>

      <LegalSection id="service" title="2. The Service">
        <Typography variant="body1">
          The Service provides tools to explore rural development solutions,
          create and manage local projects, and interact with an assistant
          ("wizard"). TODO(legal): describe the scope of the Service and any
          eligibility restrictions.
        </Typography>
      </LegalSection>

      <LegalSection id="accounts" title="3. Accounts and eligibility">
        <Typography variant="body1">
          Some features require a registered account. You are responsible for
          keeping your credentials confidential and for all activity under your
          account. TODO(legal): state any minimum age and the fact that
          accounts may be subject to administrator approval.
        </Typography>
      </LegalSection>

      <LegalSection id="acceptable-use" title="4. Acceptable use">
        <Typography variant="body1">You agree not to:</Typography>
        <Typography component="ul" variant="body1" sx={{ pl: 3 }}>
          <li>use the Service for any unlawful purpose;</li>
          <li>upload content you do not have the right to share;</li>
          <li>attempt to gain unauthorised access to the Service or its data;</li>
          <li>disrupt or impair the operation of the Service.</li>
        </Typography>
        <Typography variant="body1">
          TODO(legal): finalise the list of prohibited conduct.
        </Typography>
      </LegalSection>

      <LegalSection id="user-content" title="5. Your content">
        <Typography variant="body1">
          You retain ownership of the content you submit. You grant us the
          permission needed to host, process and display that content in order
          to provide the Service. Content submitted to the wizard/assistant may
          be processed by third-party services — see the Privacy Notice.
        </Typography>
        <Typography variant="body1">
          TODO(legal): define the licence granted to the controller and how it
          ends.
        </Typography>
      </LegalSection>

      <LegalSection id="intellectual-property" title="6. Intellectual property">
        <Typography variant="body1">
          The Service, its software and its original content are protected by
          intellectual-property laws. TODO(legal): confirm ownership and any
          open-source or third-party licences that apply.
        </Typography>
      </LegalSection>

      <LegalSection id="third-parties" title="7. Third-party services">
        <Typography variant="body1">
          The Service relies on third-party components and may link to external
          sites. Their use may be subject to their own terms. TODO(legal):
          list the relevant third-party services.
        </Typography>
      </LegalSection>

      <LegalSection id="availability" title="8. Availability and changes">
        <Typography variant="body1">
          We may modify, suspend or discontinue all or part of the Service.
          TODO(legal): describe the level of availability offered, if any.
        </Typography>
      </LegalSection>

      <LegalSection id="disclaimer" title="9. Disclaimers">
        <Typography variant="body1">
          The Service is provided "as is" to the extent permitted by law.
          TODO(legal): finalise the warranty disclaimer.
        </Typography>
      </LegalSection>

      <LegalSection id="liability" title="10. Limitation of liability">
        <Typography variant="body1">
          TODO(legal): state the limitation of liability, to the extent
          permitted by applicable law.
        </Typography>
      </LegalSection>

      <LegalSection id="termination" title="11. Suspension and termination">
        <Typography variant="body1">
          We may suspend or terminate access for breach of these Terms. You may
          stop using the Service at any time. TODO(legal): describe account
          deletion and its consequences.
        </Typography>
      </LegalSection>

      <LegalSection id="changes" title="12. Changes to these Terms">
        <Typography variant="body1">
          We may update these Terms from time to time. Material changes will be
          communicated through the Service or by email. TODO(legal): define the
          notice period and how acceptance is obtained.
        </Typography>
      </LegalSection>

      <LegalSection id="law" title="13. Governing law">
        <Typography variant="body1">
          TODO(legal): state the governing law and the competent courts.
        </Typography>
      </LegalSection>

      <LegalSection id="contact" title="14. Contact">
        <Typography variant="body1">
          Questions about these Terms can be sent to {PRIVACY_CONTACT_EMAIL}.
        </Typography>
      </LegalSection>
    </LegalPage>
  );
};

export default TermsOfUse;
